export const WIZARD_STEPS = ['Scope', 'Vital Elements', 'Pricing', 'Reason Code', 'Review'] as const;
export type WizardStepLabel = (typeof WIZARD_STEPS)[number];

export type ScopeMode = 'all' | 'departments' | 'parentSkus';

export type VitalElement = 'parentSku' | 'colorCode' | 'sizeCode';

export type PricingMode = 'blank' | 'resalePrice' | 'percentOff';

export interface WizardState {
  scopeMode: ScopeMode;
  selectedDepartments: string[];
  selectedCategories: string[];
  parentSkuInput: string;
  selectedVitalElements: VitalElement[];
  pricingMode: PricingMode;
  percentOff: number;
  overrideType: string;
  overrideCodeSuffix: string;
  reasonCode: string;
}

export const INITIAL_WIZARD_STATE: WizardState = {
  scopeMode: 'all',
  selectedDepartments: [],
  selectedCategories: [],
  parentSkuInput: '',
  selectedVitalElements: [],
  pricingMode: 'blank',
  percentOff: 0,
  overrideType: '',
  overrideCodeSuffix: '',
  reasonCode: '',
};

export interface CatalogTemplateRow {
  parentSku: string | null;
  skuSubcode: string | null;
  color: string | null;
  colorCode: string | null;
  sizeCode: string | null;
  department: string | null;
  partnerCategory: string | null;
  price: number | null;
  yerdlePrice: number | null;
  title: string | null;
}
